import { render, staticRenderFns } from "./AssignSecondApprover.vue?vue&type=template&id=5d67dbb6&scoped=true&"
import script from "./AssignSecondApprover.vue?vue&type=script&lang=ts&"
export * from "./AssignSecondApprover.vue?vue&type=script&lang=ts&"
import style0 from "./AssignSecondApprover.vue?vue&type=style&index=0&id=5d67dbb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67dbb6",
  null
  
)

export default component.exports